import LocaleProvider from 'antd/lib/locale-provider'

import { changeConfirmLocale } from 'antd/lib/modal/locale'

// https://github.com/ant-design/ant-design/pull/29570/files
LocaleProvider.prototype.componentWillUnmount = function () {
  changeConfirmLocale(this.props.locale && this.props.locale.Modal)
}

import 'antd/lib/locale-provider/style'

export * from 'antd/lib/locale-provider'

export default LocaleProvider
